import axios from "axios";

const apiService = (baseURL) => {
  const axiosInstance = axios.create({
    baseURL,
    withCredentials: true,
  });

  axiosInstance.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  );

  return axiosInstance;
};

const requestHandler = (request) => {
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  requestInterceptorsHandler(error);
  return Promise.reject(error);
};

const requestInterceptorsHandler = (res) => {
  const { response = {} } = res;
  if (response?.status === 401 || response?.systemMessage?.status === 401) {
    let HOST = response?.data?.data?.host || "";
    HOST = HOST + window.location.href;
    window.location.replace(decodeURIComponent(encodeURIComponent(HOST)));
  }
};

export default apiService;
